export default {"src":"/_next/static/media/surprised-face.e3de4f13.svg","height":54,"width":57,"blurWidth":0,"blurHeight":0};